module.exports = __webpack_public_path__ + "static/media/graphic-design.c4ebebc9.svg";